import React, { createContext, useContext, useState, useEffect, useRef } from 'react';
import { io } from 'socket.io-client';
import { useAppContext } from './AppContext';
import { getNotifications } from '../api/notifications';

const NotificationContext = createContext();

export const useNotifications = () => useContext(NotificationContext);

export const NotificationProvider = ({ children }) => {
    const [notifications, setNotifications] = useState([]);
    const { user } = useAppContext();
    const socketRef = useRef(null);

    const refreshNotifications = async () => {
        try {
            await getNotifications((data) => {
                setNotifications(data);
            });
        } catch (err) {
            console.error('Failed to refresh notifications:', err);
        }
    };
    useEffect(() => {
        if (user?.id && !socketRef.current) {
            getNotifications((data) => {
                setNotifications(data);
            })
            // Create and connect socket
            socketRef.current = io('http://localhost:3005', {
                transports: ['websocket'], // optional: can help avoid CORS issues
            });

            socketRef.current.on('connect', () => {
                console.log('🔌 Socket connected:', socketRef.current.id);

                // Register this client with the user's ID
                socketRef.current.emit('register', user.id);
            });

            socketRef.current.on('new_notification', (notification) => {
                // Log the notification data and add custom text
                console.log('New notification received:', notification);
                console.log('This is the notification for user:', user.id);

                // Update the state with the new notification
                setNotifications((prev) => [notification, ...prev]);
            });

            socketRef.current.on('disconnect', () => {
                console.log('Socket disconnected');
            });
        }

        return () => {
            if (socketRef.current) {
                socketRef.current.disconnect();
                socketRef.current = null;
            }
        };
    }, [user]);

    const markAsRead = (id) => {
        setNotifications((prev) =>
            prev.map((n) => (n.id === id ? { ...n, is_read: true } : n))
        );
    };

    return (
        <NotificationContext.Provider value={{ notifications, markAsRead, refreshNotifications }}>
            {children}
        </NotificationContext.Provider>
    );
};
